export const ocpoContactInfo = {
	phone: "(384-2) 58-32-89",
	localPhone: "4-62, 3-46, 4-65",
	email: "ocpo@kemsu.ru",
}
